export var TYPE_LABELS = {
  Payment:    { singular: 'Payment',     plural: 'Payments'    },
  CreditNote: { singular: 'Credit Note', plural: 'Credit Notes' },
  Refund:     { singular: 'Refund',      plural: 'Refunds'     },
  Invoice:    { singular: 'Invoice',     plural: 'Invoices'    },
  WriteOff:   { singular: 'Write Off',   plural: 'Write Offs'  },
  WriteBack:  { singular: 'Write Back',  plural: 'Write Backs' }
}

export function getTypeSingular (type) {
  return (TYPE_LABELS[type] && TYPE_LABELS[type].singular) || type
}

export function getTypePlural (type) {
  return (TYPE_LABELS[type] && TYPE_LABELS[type].plural) || type
}
